const flights = {
  flight: "Skrydis", // translated 
  flights: "Skrydžiai", // translated 
  originDepartureDate: "Išvykimas", // translated 
  destinationDepartureDate: "Grįžti", // translated 
  outbound: "Išeinantis", // translated 
  inbound: "Įeinantis", // translated 
  travelTime: "Kelionės laikas", // translated 
  selected: "pasirinktas", // translated 
  select: "pasirinkite", // translated 
  airline: "Aviakompanija", // translated 
  directFlight: "Tiesioginis skrydis", // translated 
  baggage: "Bagažas", // translated 
  stops: "Sustoja", // translated 
  nonStop: "Be sustojimo", // translated 
  oneStopMax: "Vienas sustojimas maks", // translated 
  twoStopsMax: "Maks. du sustojimai", // translated 
  anyStops: "Su bet kokiais sustojimais", // translated 
  smallBaggage: "Mažas bagažas", // translated 
  bigBaggage: "Didelis bagažas", // translated 
  smallAndBigBaggage: "Mažas ir didelis bagažas", // translated 
  outboundStops: "Išvykimo stotelės", // translated 
  inboundStops: "Atvykimo stotelės", // translated 
  selectAirline: "Pasirinkite aviakompaniją", // translated 
  baggageOption: "Bagažo pasirinkimas", // translated 
  outboundDepartureAfter: "Išvykimas po", // translated 
  outboundArrivalAfter: "Išvykstamasis atvykimas po", // translated 
  inboundDepartureAfter: "Atvykimas išvykimas po", // translated 
  inboundArrivalTimeAfter: "Atvykimas po", // translated 
  flightClass: "Skrydžio klasė", // translated 
  outboundDepAfter: "Išvykimas po", // translated 
  outboundArrivalAfrer: "Atvykimas po", // translated 
  inboundDepAfter: "Išvykstant po", // translated 
  inboundArrivalAfter: "Atvykus po", // translated 
  airlines: "Oro linijų bendrovė (-ės)", // translated 
  lessThan: "Mažiau nei", // translated 
  layover: "Persėdimas", // translated 
  duration: "Trukmė", // translated 
  economy: "Ekonomika", // translated 
  business: "Verslas", // translated 
  with: "Su", // translated 
  without: "Be", // translated 
  twoOrMore: "Du ar daugiau", // translated 
  departure: "Išvykimas", // translated 
  return: "Grįžti", // translated 
  submit: "Pateikti", // translated 
  priceLessThan: "Kaina mažesnė nei", // translated 
  durationLessThan: "Trukmė mažesnė nei", // translated 
  layoverLessThan: "Persėdimas mažiau nei", // translated 
  noLayover: "Jokio persėdimo", // translated 
  durationLowestFirst: "Trukmė (pirmiausia mažiausia)", // translated 
  durationHighestFirst: "Trukmė (pirmiausia aukščiausia)", // translated 
  idType: "ID tipas", // translated 
  idPassportCode: "ID / paso kodas", // translated 
  expirationDate: "Galiojimo laikas", // translated 
  frequentFlyerNumber: "Nuolatinio keleivio numeris", // translated 
  frequentFlyerAirline: "„Frequent Flyer Airline“.", // translated 
  dateOfBirth: "Gimimo data", // translated 
  infant: "Kūdikis", // translated 
  phone: "Telefonas", // translated 
  title: "Pavadinimas", // translated 
  noLuggageIncluded: "Į kainą neįskaičiuotas bagažas", // translated 
  includesLuggage: "Apima bagažą", // translated 
  outboundFlight: "Išvykstamasis skrydis", // translated 
  inboundFlight: "Įeinantis skrydis", // translated 
  flightNumber: "Skrydžio numeris", // translated 
  flightNumbers: "Skrydžio numeriai", // translated 
  cabinClassType: "Kabinos klasės tipas", // translated 
  aircraftType: "Lėktuvo tipas", // translated 
  airlineName: "Oro linijų pavadinimas", // translated 
  no: "Nr", // translated 
  yes: "Taip", // translated 
  anyFlights: "Bet kokie skrydžiai", // translated 
  oneStop: "Vienas sustojimas", // translated 
  direct: "Tiesioginis", // translated 
  directFlights: "Tiesioginiai skrydžiai", // translated 
  all: "Visi", // translated 
  first: "Pirmas", // translated 
  premiumEconomy: "Prem. Ekonomika", // translated 
  withBaggageOnly: "Tik su bagažu", // translated 
  oneWay: "Vienas kelias", // translated 
  roundTrip: "Kelionė pirmyn ir atgal", // translated 
  withBaggage: "Su bagažu", // translated 
  noBaggage: "Nėra bagažo", // translated 
  requiredFields: "privalomi laukai", // translated 
  nonRequiredFields: "Nebūtini laukai", // translated 
  cabinClass: "Kabinos klasė", // translated 
  brandName: "Markės pavadinimas", // translated 
  performNewSearch: "Atlikite naują paiešką", // translated 
  outboundDeparture: "Išvykimas", // translated 
  inboundDeparture: "Įeinantis išvykimas", // translated 
  created: "Sukurta", // translated 
  freeCancellationAvailable: "Galimas nemokamas atšaukimas", // translated 
  freeCancellationDeadline: "Nemokamas atšaukimo terminas", // translated 
  externalReference: "Išorinė nuoroda", // translated 
  outboundflightNumber: "Išvykstančio skrydžio numeris", // translated 
  inboundflightNumber: "Atvykstančio skrydžio numeris", // translated 
  arrival: "Atvykimas", // translated 
};



export default flights;
